export default "__VITE_ASSET__DA475vxl__"